/**
 * Hand-rolled single-image lightbox.
 *
 * Mounted lazily under <body> on first openLightbox() call. ESC + click-outside
 * close. No carousel, no zoom — the marketplace cards have a single screenshot
 * each, and the goal is just "let me see the full-res asset I uploaded."
 */

let root: HTMLDivElement | null = null;
let img: HTMLImageElement | null = null;
let onKey: ((e: KeyboardEvent) => void) | null = null;

function ensureRoot(): HTMLDivElement {
  if (root) return root;
  const r = document.createElement('div');
  r.className = 'mp-lightbox';
  r.setAttribute('role', 'dialog');
  r.setAttribute('aria-modal', 'true');
  r.setAttribute('aria-hidden', 'true');

  const inner = document.createElement('div');
  inner.className = 'mp-lightbox-inner';

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'mp-lightbox-close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '×';
  closeBtn.addEventListener('click', closeLightbox);

  const i = document.createElement('img');
  i.alt = '';
  img = i;

  inner.append(i, closeBtn);
  r.appendChild(inner);
  r.addEventListener('click', (e) => {
    if (e.target === r) closeLightbox();
  });

  document.body.appendChild(r);
  root = r;
  return r;
}

export function openLightbox(src: string, alt = ''): void {
  const r = ensureRoot();
  if (!img) return;
  img.src = src;
  img.alt = alt;
  r.classList.add('open');
  r.setAttribute('aria-hidden', 'false');
  if (!onKey) {
    onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();
    };
    document.addEventListener('keydown', onKey);
  }
}

export function closeLightbox(): void {
  if (!root) return;
  root.classList.remove('open');
  root.setAttribute('aria-hidden', 'true');
  if (img) img.src = '';
  if (onKey) {
    document.removeEventListener('keydown', onKey);
    onKey = null;
  }
}
